export const onBoarding_Data = (data) => ({
    type: 'ONBOARDING_question_listing',
    payload: { 
      data: data,
    }
  });
  